import { en, ru, zh } from '@/locales';
import { useEnhancedRouter } from './useEnhancedRouter';

export const useTranslations = (): typeof ru => {
  const { locale } = useEnhancedRouter();

  if (locale === 'ru' || locale === 'ru-RU') return ru;
  if (locale === 'zh-CN' || locale === 'zh') return zh;
  return en;
};
